import {
  useBillingCompanySetPricePlanMutation,
  useBillingCompanySetPricePlanPeriodMutation,
} from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

const useSetOrganizationPricePlan = () => {
  const [setPricePlanMutation, setPricePlanMutationResult] = useBillingCompanySetPricePlanMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });
  const [setPricePlanPeriodMutation, setPricePlanPeriodMutationResult] = useBillingCompanySetPricePlanPeriodMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const setPricePlanRequest = async (organizationId: string, pricePlanId: string, pricePlanPeriodId?: string) => {
    try {
      const mutationResult = await setPricePlanMutation({
        variables: {
          input: {
            companyId: organizationId,
            pricePlanPeriodId,
            pricePlanId,
          },
        },
        refetchQueries: ['billingOrganizationCurrentPricePlan'],
      });

      return mutationResult.data?.result?.ok;
    } catch (e) {
      return undefined;
    }
  };

  const setPricePlanPeriodRequest = async (organizationId: string, pricePlanPeriodId: string) => {
    try {
      const mutationResult = await setPricePlanPeriodMutation({
        variables: {
          input: {
            companyId: organizationId,
            pricePlanPeriodId,
          },
        },
        refetchQueries: ['billingOrganizationCurrentPricePlan', 'billingCompanyBillingInfo'],
      });

      return mutationResult.data?.result?.ok;
    } catch (e) {
      return undefined;
    }
  };

  return {
    setPricePlanRequest,
    setPricePlanPeriodRequest,
    pricePlanData: {
      error: setPricePlanMutationResult.error,
      loading: setPricePlanMutationResult.loading,
      called: setPricePlanMutationResult.called,
    },
    pricePlanPeriodData: {
      error: setPricePlanPeriodMutationResult.error,
      loading: setPricePlanPeriodMutationResult.loading,
      called: setPricePlanPeriodMutationResult.called,
    },
  };
};

export default useSetOrganizationPricePlan;
